import React, { useEffect, useState } from "react";
import * as Icons from "heroicons-react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import powered from "../../../../logo-dark.svg";
import { signInUser } from "../../../Utility/Auth";
import productPhoto from "../../../../product.jpg";

import {
  salesAmountRecived,
  saleCash,
  saleCardName,
  saleCardAmount,
  saleMfsName,
  saleMfsAmount,
  salePointAmount,
  saleDiscount,
  selcetBiller,
  selectWarehouse,
  setDue,
  removeQuantityReducer,
  addQuantityReducer,
  removeItemFormCartReducer,
  saleReturnProducts,
  removeItemFormReturnCartReducer,
} from "../../../../features/posSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  itemVat,
  // posFinalizer,
  itemVatTotal,
  toDecimal,
} from "../../../Utility/PosCalculations";
import POS3BillGenerate from "../../../Common/Modal/POS3BillGenerate";
import PriceSelectByProduct from "../../../Common/CustomSelect/PriceSelectByProduct";
import { useSettingsQuery } from "../../../../services/settingsApi";

const PosFinalizes = React.forwardRef(
  ({
    // customer,
    handlePrintBill,
    billPrintButton,
    // returnCal,
    usePointChecked,
    usePointCheckbox,
    discountChecked,
    // setDiscountChecked,
    discountCheckbox,
    paymentShow,
    setPaymentShow,
    isBill,
    settings,
  }) => {
    const dispatch = useDispatch();
    const posData = useSelector((state) => state.posReducer);
    const auth = signInUser();
    const { data: dbSettings } = useSettingsQuery(auth?.aamarId, {
      skip: !auth?.aamarId,
    });
    const currentSettings = settings || dbSettings || auth?.storeSettings;
    const isPriceEditable = Boolean(currentSettings?.isPriceEditable);

    // console.log(posData)
    const handlePaymentClose = () => setPaymentShow(false);

    const returnCustomQuantity = (qty, article_code) => {
      //console.log(qty)
      if (posData?.returnProducts) {
        // Find the selected item and the rest of the items
        const selectedItem = posData?.returnProducts.find(
          (p) => p.article_code === article_code
        );
        const restItems = posData?.returnProducts.filter(
          (p) => p.article_code !== article_code
        );

        if (!selectedItem) {
          console.error(
            "Item not found in cart with article_code:",
            article_code
          );
          return;
        }

        // Ensure `qty` is parsed as an integer
        const parsedQty = parseFloat(qty);

        // Update quantity based on conditions
        let newQty = selectedItem.qty; // Default to current quantity

        if (parsedQty >= 0 && parsedQty <= selectedItem.max_qty) {
          newQty = parsedQty; // Within range
        } else if (parsedQty > selectedItem.max_qty) {
          newQty = selectedItem.max_qty; // Cap to max quantity
        } else {
          newQty = 0; // Default to 0 if invalid
        }

        // Update selectedItem with the new quantity
        const updatedSelectedItem = {
          ...selectedItem,
          qty: newQty,
        };

        // Combine updated items and sort
        const updatedCart = [...restItems, updatedSelectedItem].sort(
          (a, b) => a.order - b.order
        );

        // Dispatch the updated cart
        dispatch(saleReturnProducts(updatedCart));
      }
    };

    return (
      <div className="">
        <div className="card sticky-md-top">
          <div className="mb-2">
            <div className="row p-3 pb-0">
              <div className="col-8">
                <p className="card-text mb-0  py-1">
                  <b>Total Item: </b>{" "}
                  <span className=""> {posData?.totalItem}</span>
                </p>
                {posData.returnCal?.totalItem > 0 && (
                  <p className="card-text mb-0">
                    <b>Return Item: </b>{" "}
                    <span className="">
                      {parseFloat(posData.returnCal.totalItem)}
                    </span>
                  </p>
                )}
              </div>
              <div className="col-4">
                <div className="d-flex justify-content-end">
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check
                      type="checkbox"
                      label="Due Bill"
                      onChange={() => dispatch(setDue(!posData.due))}
                      checked={posData.due}
                      disabled={
                        posData.customerId === "62e301c1ee6c8940f6ac1515"
                      }
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
            <hr className="m-2 p-0" />
            <div
              className="card-body row"
              style={{ height: "450px", overflowY: "scroll", display: "block" }}
            >
              {posData?.products?.length > 0 ? (
                posData?.products?.map((pro) => {
                  return (
                    <div className="rounded col-12 mb-2" key={pro._id}>
                      <div className="mx-auto d-flex justify-content-between  gap-1 rounded p-1 shadow-sm ">
                        {/* Product Image */}
                        <div className=" p-1 col-2 d-flex align-items-center">
                          {/* {console.log(
                            "Product Data ",
                            pro
                          )} */}
                          <img
                            style={{
                              borderRadius: "5px",
                              width: "100%",
                              objectFit: "cover",
                            }}
                            src={
                              pro?.photo
                                ? `${
                                    process.env.REACT_APP_PHOTO_URL
                                  }${encodeURIComponent(pro?.photo)}`
                                : productPhoto
                            }
                            alt="Product"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = productPhoto;
                            }}
                          />
                        </div>
                        <div className="col-10">
                          <div className="d-flex align-items-start">
                            <div className="col-10">
                              {/* Product Name */}
                              <p className="fs-6 mt-2 mb-2 fw-normal text-left">
                                {pro.name}
                              </p>
                            </div>
                            <div className="col-2 p-2">
                              <Icons.X
                                className="float-end"
                                size={18}
                                onClick={() =>
                                  dispatch(
                                    removeItemFormCartReducer(pro.article_code)
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div className="d-flex justify-content-between align-items-start gap-1 flex-nowrap mt-1">
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              style={{ width: "80px", minWidth: "75px", flexShrink: 0 }}
                            >
                              <PriceSelectByProduct
                                sc={pro.id || pro._id}
                                setVal={pro.mrp}
                                tp={pro.tp}
                                article_code={pro.article_code}
                                compact={true}
                                editable={isPriceEditable}
                              />
                            </div>

                            <div
                              className="d-flex align-items-center border rounded bg-light"
                              style={{
                                height: "30px",
                                flexShrink: 0,
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-sm p-0 d-flex align-items-center justify-content-center text-dark border-0 bg-transparent"
                                style={{
                                  width: "22px",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  dispatch(
                                    removeQuantityReducer(pro.article_code)
                                  )
                                }
                              >
                                <Icons.Minus size={13} />
                              </button>
                              <span
                                className="text-center fw-bold px-1"
                                style={{
                                  minWidth: "20px",
                                  fontSize: "13px",
                                  lineHeight: "30px",
                                  userSelect: "none",
                                }}
                              >
                                {pro?.qty}
                              </span>
                              <button
                                type="button"
                                className="btn btn-sm p-0 d-flex align-items-center justify-content-center text-dark border-0 bg-transparent"
                                style={{
                                  width: "22px",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  dispatch(
                                    addQuantityReducer(pro.article_code)
                                  )
                                }
                              >
                                <Icons.Plus size={13} />
                              </button>
                            </div>

                            <div
                              className="text-end fw-bold text-nowrap d-flex align-items-center justify-content-end"
                              style={{
                                height: "30px",
                                fontSize: "13px",
                                color: "#212529",
                                flexShrink: 0,
                                minWidth: "55px",
                              }}
                            >
                              {toDecimal(
                                itemVatTotal(pro.vat, pro.qty, pro.mrp)
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="d-flex justify-center align-items-center flex-col">
                  <Icons.ArchiveOutline size={30} />
                  No Producs in Cart
                </div>
              )}
              {posData?.returnProducts?.length > 0 && (
                <>
                  <p className="pt-4">
                    <b>Return Poducts</b>
                  </p>
                  {posData?.returnProducts?.map((pro) => {
                    return (
                      <div className="rounded col-12 mb-2" key={pro._id}>
                        <div className="mx-auto d-flex justify-content-between  gap-1 rounded p-1 shadow-sm ">
                          {/* Product Image */}
                          <div className=" p-1 col-2 d-flex align-items-center">
                             {/* {console.log(
                            "photo ",
                            pro
                          )} */}
                            <img
                              style={{
                                borderRadius: "5px",
                                // height: "50%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              // src={pro.photo || productPhoto}
                              src={
                                pro?.photo
                                  ? `${
                                      process.env.REACT_APP_PHOTO_URL
                                    }${encodeURIComponent(pro?.photo)}`
                                  : productPhoto
                              }
                              alt="Product"
                            />
                          </div>
                          <div className="col-10">
                            <div className="d-flex align-items-start">
                              <div className="col-10">
                                {/* Product Name */}
                                <p className="fs-6 mt-2 mb-2 fw-normal text-left">
                                  {pro.name}
                                </p>
                              </div>
                              <div className="col-2 p-2">
                                <Icons.X
                                  className="float-end"
                                  size={18}
                                  onClick={() =>
                                    dispatch(
                                      removeItemFormReturnCartReducer(
                                        pro.article_code
                                      )
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                              <div className="text-center d-flex justify-content-center align-items-center">
                                <p className="fw-bold fs-6 d-flex gap-1 p-0 m-0">
                                  <span>{pro?.mrp}</span>
                                  <small className="fs-xs fw-light">৳</small>
                                </p>
                              </div>

                              <div className="d-flex align-items-center">
                                <div className="w-30" style={{ width: "80px" }}>
                                  <input
                                    type="number"
                                    className="form-control quantity"
                                    id={pro.article_code}
                                    onChange={(e) =>
                                      returnCustomQuantity(
                                        e.target.value,
                                        pro.article_code
                                      )
                                    }
                                    value={pro.qty}
                                  />
                                  {/* <div className="input-group-prepend">
                            <div
                              onClick={() => dispatch(removeQuantityReducer(pro.article_code))}
                              className="input-group-text p-1"
                            >
                              <Icons.Minus size="18" />
                            </div>
                          </div> */}
                                  {/* <div className="px-3 text-center fw-normal">{pro?.qty}</div> */}
                                  {/* <div className="input-group-append">
                            <div
                              onClick={() => dispatch(addQuantityReducer(pro.article_code))}
                              className="input-group-text p-1" 
                            >
                              <Icons.Plus size="18" />
                            </div>
                          </div> */}
                                </div>
                              </div>

                              <div className="col-3 d-flex justify-content-center align-items-center">
                                {toDecimal(
                                  itemVatTotal(pro.vat, pro.qty, pro.mrp)
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>

          <div className="card-footer">
            {/* Calcullations */}
            <div className="row">
              <p className="card-text mb-0 border-bottom py-1">
                <b>Total: </b>
                <span className="float-end">
                  {" "}
                  {parseFloat(posData?.total).toFixed(2)}
                  BDT
                </span>
              </p>
              {/* {posData.returnCal?.total > 0 && (
                <p className="card-text mb-0 border-bottom py-1">
                  <b>Return Total: </b>
                  <span className="float-end">
                    {" "}
                    {parseFloat(posData.returnCal.grossTotal).toFixed(2)}BDT
                  </span>
                </p>
              )} */}
              {/* <p className="card-text mb-0 border-bottom py-1">
                <b>Discount Amount: </b>{" "}
                <span className="float-end"> {sales.discount} BDT</span>
              </p> */}
              <p className="card-text mb-0 border-bottom py-1">
                <b>Discount: </b>{" "}
                <span className="float-end">
                  {" "}
                  {parseFloat(posData?.discount)?.toFixed(2)}
                  BDT
                </span>
              </p>
              {/* <p className="card-text mb-0 border-bottom py-1">
                <b>Gross Total: </b>
                <span className="float-end">
                  {parseFloat(posData?.grossTotal)?.toFixed(2)}
                  BDT
                </span>
              </p> */}
              <p className="card-text mb-0 border-bottom py-1">
                <b>Gross Total: </b>
                <span className="float-end">
                  {parseFloat(posData?.grossTotalRound)?.toFixed(2)}
                  BDT
                </span>
              </p>
            </div>
            <div>
              <button
                onClick={() => setPaymentShow(true)}
                disabled={
                  posData?.products?.length < 0 ||
                  posData?.returnProducts?.length < 0
                }
                className="btn btn-dark btn-md btn-block w-100 py-2 my-3"
              >
                Place Order
              </button>
            </div>
            <div className="text-center mt-2">
              <span
                className="text-sm"
                style={{ fontSize: "12px", color: "#6c757d" }}
              >
                Powered by:
              </span>
              <Link to="https://techsoulbd.com/">
                <img src={powered} height="25" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <POS3BillGenerate
          handlePrintBill={handlePrintBill}
          title="Generate Order"
          onShow={paymentShow}
          handleClose={handlePaymentClose}
        ></POS3BillGenerate>
      </div>
    );
  }
);

export default PosFinalizes;
